import { useContext } from 'react';

import { ParentAuthContext } from '../contexts/ParentAuthContext';

export default function useParentAuth() {
  return useContext(ParentAuthContext);
}
